import React from "react";
import { Flame, Sun, Snowflake } from "lucide-react";
import { useT } from "../../context/LanguageContext";

const STYLES = {
  hot: {
    tKey: "dash.scoreHot",
    icon: Flame,
    cls: "bg-red-100 text-red-800 border-red-200",
  },
  warm: {
    tKey: "dash.scoreWarm",
    icon: Sun,
    cls: "bg-amber-50 text-amber-700 border-amber-100",
  },
  cold: {
    tKey: "dash.scoreCold",
    icon: Snowflake,
    cls: "bg-sky-50 text-sky-700 border-sky-100",
  },
};

export const LeadScoreBadge = ({ label, size = "sm", showIcon = true }) => {
  const { t } = useT();
  if (!label || !STYLES[label]) return null;
  const cfg = STYLES[label];
  const Icon = cfg.icon;
  const sizeCls = size === "lg"
    ? "px-3 py-1 text-sm gap-1.5"
    : "px-2 py-0.5 text-xs gap-1";
  return (
    <span
      className={`inline-flex items-center rounded-full border font-semibold ${cfg.cls} ${sizeCls}`}
      data-testid={`lead-score-badge-${label}`}
    >
      {showIcon && <Icon className={size === "lg" ? "w-3.5 h-3.5" : "w-3 h-3"} />}
      {t(cfg.tKey)}
    </span>
  );
};
